<script>
  import { onMount, onDestroy, createEventDispatcher } from 'svelte';
  import { Calendar } from '@fullcalendar/core';
  import dayGridPlugin from '@fullcalendar/daygrid';
  import timeLinePlugin from '@fullcalendar/timeline';
  import { getTime, configItem } from 'components/Helper.js';
  import moment from 'moment';
  const dispatch = createEventDispatcher();
  let calendarEl;
  let calendar;
  import { Popover } from 'bootstrap';
  export const eventClick = () => {};
  let loading = false;
  onMount(() => {
    calendar = new Calendar(calendarEl, {
      schedulerLicenseKey: configItem.schedulerLicenseKey,
      // timeZone:configItem.defaultTimezone,
      plugins: [dayGridPlugin, timeLinePlugin],
      headerToolbar: {
        left: 'prev,next today',
        center: 'title',
        right: '',
        // right: 'dayGridMonth,timelineCustom'
      },
      views: {
        dayGridMonth: {
          buttonText: 'Month',
        },
        timelineCustom: {
          type: 'timeline',
          buttonText: 'Year',
          dateIncrement: { years: 1 },
          slotDuration: { months: 1 },
          visibleRange: function (currentDate) {
            return {
              start: moment(currentDate).clone().startOf('year').format('YYYY-MM-DD'),
              end: moment(currentDate).clone().endOf('year').add(1, 'day').format('YYYY-MM-DD'),
            };
          },
        },
      },
      height: '100%',
      dayMaxEventRows: 3,
      initialDate: $$props.initialDate,
      firstDay: 0,
      initialView: $$props.initialView,
      selectable: $$props.selectable != undefined ? $$props.selectable : true,
      droppable: true,
      editable: true,
      nowIndicator: false,
      now: getTime('calender'),
      scrollTime: getTime('calenderTime'),
      themeSystem: 'bootstrap',
      eventBackgroundColor: '#fff',
      eventTextColor: '#000',
      events: $$props.events,
      weekends: true,
      moreLinkClick: function (info) {
        dispatch('moreLinkClick', {
          x: info.jsEvent.clientX,
          y: info.jsEvent.clientY,
          hiddenEvents: info.hiddenSegs.map(function (seg) {
            return {
              title: seg.event.title,
              classNames: seg.event.classNames.slice(),
              extendedProps: Object.assign({}, seg.event.extendedProps),
            };
          }),
        });
        // Returning a non-string truthy value prevents FullCalendar's internal popup.
        // FullCalendar v5 opens its popup when the return value is falsy or === 'popover',
        // and navigates to a view when it is a string — so only a non-string truthy
        // value suppresses both behaviours.
        return true;
      },
      eventClick: function (info) {
        return $$props.eventClick(info);
      },
      eventDidMount: function (info) {
        info.el.setAttribute('title', info.event.extendedProps.title);
        // var tooltip = new Popover(info.el, {
        //   content: info.event.extendedProps.title,
        //   placement: 'top',
        //   trigger: 'hover',
        //   container: info.el.parentElement,
        //   animation: false
        // });
      },
      loading: function (bool) {
        loading = bool;
      },
    });
    calendar.render();
    // TEMPORARY SOLUTION
    // TODO: remove it once the license is sorted
    if (document.querySelector('.fc-license-message')) {
      document.querySelector('.fc-license-message').className = 'fc-license-message d-none';
    }
  });

  import { dashboardData, getDashboardData, setDashboardData } from '../stores/dashboard.js';
  export const setInitialView = (flag, date, userId) => {
    calenderType = flag;
    calendar.changeView(flag);
    calendar.gotoDate(date);
    refetchEvents(flag);
    setDashboardData({
      ...getDashboardData(),
      users: [{ id: userId, userId: userId }],
    });
  };

  onDestroy(() => {
    calendar.destroy();
  });

  export const updateSize = () => {
    setTimeout(() => {
      calendar.updateSize();
    }, 500);
  };

  export const refetchEvents = () => {
    setTimeout(() => {
      calendar.refetchEvents();
    }, 500);
  };
  import Loader from '../components/Loader.svelte';
  let calenderType = 'dayGridMonth';
  export let extraFilter = {};
</script>

{#if loading}
  <div
    class="position-absolute"
    style="    width: 100%;text-align: center;padding-top: 70px;height:100%; z-index:10000000000000"
  >
    <Loader Style="loader-block" />
  </div>
{/if}
<div
  class="fc-toolbar-chunk"
  style="position:absolute;    right: 0px;"
>
  <div class="fc-button-group">
    <button
      id="btn-calender-month"
      on:click={() => {
        calenderType = 'dayGridMonth';
        extraFilter.calenderType = calenderType;
        calendar.changeView('dayGridMonth');
        if (document.getElementById('profile-tab2').getAttribute('calenderFromDate')) {
          calendar.gotoDate(
            document.getElementById('profile-tab2').getAttribute('calenderFromDate'),
          );
          document.getElementById('profile-tab2').removeAttribute('calenderFromDate');
        }
        refetchEvents(calenderType);
      }}
      class="fc-dayGridMonth-button fc-button fc-button-primary first-element {calenderType ==
      'dayGridMonth'
        ? 'fc-button-active'
        : ''}"
      type="button">Month</button
    >
    <button
      id="btn-calender-year"
      on:click={() => {
        calenderType = 'timelineCustom';
        extraFilter.calenderType = calenderType;
        calendar.changeView('timelineCustom');
        if (document.getElementById('profile-tab2').getAttribute('calenderFromDate')) {
          calendar.gotoDate(
            document.getElementById('profile-tab2').getAttribute('calenderFromDate'),
          );
          document.getElementById('profile-tab2').removeAttribute('calenderFromDate');
        }
        refetchEvents(calenderType);
      }}
      class="fc-timelineCustom-button fc-button fc-button-primary last-element {calenderType ==
      'timelineCustom'
        ? 'fc-button-active'
        : ''}"
      type="button">Year</button
    >
  </div>
</div>
<div bind:this={calendarEl} />
